export { StoreDeliveryCodeEnum, StoreStatusEnum } from './stores-list.enum';
